<template>
  <footer class="app_footer">
    <!-- 联系我们 -->
    <!-- 其它 -->
    <div class="extra">
      <div class="container-footer">
        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <div class="linkus">
              <div style="color: #ffe; font-weight: 600; margin-bottom: 5px">
                <!-- 友情链接： -->
              </div>
              <p style="margin-top: 10px">
                <a href="">平台首页</a>
                <a href="https://www.cec.org.cn/" target="_blank"
                  >中国电力企业联合会</a
                >
                <a href="https://creditpower.cec.org.cn/" target="_blank"
                  >信用电力</a
                >
                <a href="https://fw.cec.org.cn/" target="_blank">电力大数据</a>
              </p>
            </div>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-row class="slogan" :gutter="20">
              <el-col :span="8" :offset="0">
                <a class="" href="javascript:;">
                  <img class="qrcode" src="../../../assets/zdl_qr.jpg" alt="" />
                </a>
              </el-col>
              <el-col :span="16" :offset="0">
                <div class="address">
                  <p>地址 : 北京市丰台区槐房西路9号院7号楼</p>
                  <p>电话 : 010-83935995/83935996</p>
                  <p>邮箱 : creditinvestigation@cec.org.cn</p>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 版权信息 -->
        <div class="copyright">
          <p>
            中电联（北京）征信有限公司 | CopyRight ©
            <a
              data-v-37dfd6fc=""
              target="_blank"
              href="https://beian.miit.gov.cn/"
              >京ICP备2020042117号-1</a
            >
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
}
</script>

<style scoped lang="less">
.app_footer {
  overflow: hidden;
  background-color: #f5f5f5;

  .extra {
    background-color: #333;

    .container-footer {
      padding: 10px 0;
    }

    .qrcode {
      width: 100px;
      height: 100px;
      // padding: 7px;
      // border: 1px solid #ededed;
    }

    .linkus {
      float: right;
      width: 460px;
      min-width: 400px;
      height: 110px;

      a {
        color: #eee;
        white-space: pre-wrap;
        padding: 5px 20px 5px 0px;
      }

      a:hover {
        color: #409eff;
      }
    }

    .slogan {
      width: 50%;
      min-width: 400px;
      height: 110px;
      line-height: 30px;
      // padding: 10px 0px;
      border-bottom: 1px solid #434343;
      justify-content: space-around;

      a {
        float: left;
        color: #fff;
      }

      .address {
        min-width: 400px;
        color: #fff;
        text-align: left;
      }
    }
  }

  .copyright {
    height: 50px;
    padding-top: 15px;
    text-align: center;
    color: #999;
    font-size: 15px;

    p {
      line-height: 1;
      margin-bottom: 20px;
    }

    a {
      color: #409eff;
      line-height: 1;
      padding: 0 10px;
      border-right: 1px solid #999;

      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
